export default function getNewEditorCheck(penURL) {
  return penURL.includes("/editor/");
}
